<template>
  <div>
    <generic-container
      :title="$t('quotation list')"
      icon="file alternate o outline"
      :header_buttons="header_buttons"
      :show_plus="true"
      :configurable="true"
      :configure_modal="custom_configuration_modal"
      @add="add"
    >
      <table
        class="ui celled very compact selectable striped table"
        ref="table"
        style="width:100%"
      >
        <thead>
          <tr>
            <th>{{ $t("name") }}</th>
            <th>{{ $t("customer") }}</th>
            <th>{{ $t("create date") }}</th>
            <!-- <th>{{ $t("options") }}</th> -->
          </tr>
        </thead>
        <tbody></tbody>
      </table>
    </generic-container>
    <template v-for="(mdl, index) in quotation_modals">
      <component
        :is="mdl"
        :key="index"
        :quotation_in="selected_quotation"
        @destroy="destroy"
        @succedded="succedded"
        @deleted="deleted"
      ></component>
    </template>
  </div>
</template>

<script>
// import { local_api } from "@/utils";
// import { cloneDeep } from "lodash";
import { init_ajax_data_datables, enterprise_setup } from "@/utils";
import filters from "@/filters";
import GenericContainer from "@/components/GenericContainer";
import QuotationModal from "./quotation_modal/QuotationModal";
import CustomConfigurationModal from "./custom_configuration_modal/Index";

// @ is an alias to /src
export default {
  name: "QuotationIndex",
  components: {
    "generic-container": GenericContainer,
  },
  filters: filters,
  data() {
    return {
      quotation_modals: [],
      selected_quotation: undefined,
      header_buttons: [],
      table: undefined,
      custom_configuration_modal: CustomConfigurationModal,
    };
  },
  computed: {},
  methods: {
    add() {
      // this.quotation_modals.push(QuotationModal);
      this.$router.push({
        name: "QuotationComposerIndex",
      });
    },
    succedded() {
      this.table.ajax.reload();
      this.destroy();
    },
    deleted(p) {
      let idx = this.quotations.findIndex((r) => r.uuid == p.uuid);
      if (idx >= 0) this.quotations.splice(idx, 1);
      this.destroy();
    },
    destroy() {
      setTimeout(() => {
        this.quotation_modals = [];
        this.selected_quotation = undefined;
      }, 300);
    },
    show_quotation(quotation) {
      this.selected_quotation = quotation;
      this.quotation_modals.push(QuotationModal);
    },
  },
  mounted() {
    let vm = this;
    let ent_setup = enterprise_setup(vm);
    let columns = [
      {
        data: function(row) {
          return row.name;
        },
      },
      {
        data: function(row) {
          return row.ctm_customer ? row.ctm_customer.name : vm.$t("unknown");
        },
      },
      {
        data: function(row) {
          return filters.formatDate(
            row.create_date,
            ent_setup.detailed_date_format,
          );
        },
      },
    ];

    let onSelect = (data) => {
      vm.show_quotation(data);
    };

    vm.table = init_ajax_data_datables(
      vm,
      vm.$refs.table,
      window.jQuery.fn.api.settings.api["quotation url"],
      columns,
      onSelect,
    );
  },
  watch: {},
};
</script>
